import * as env from 'src/lib/env';
import * as log from 'src/lib/log';

const URL_INDEX = '/FE_METADATA.json';

const fetchFEBuildTag = () => {
  // Add timestamp to URL, to overcome "read from disk cache" issue
  const url = `${URL_INDEX}?t=${Date.now()}`;

  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Error requesting FE build metadata file');
      }

      return response.json();
    })
    .then((data) => data.TAG);
};

export function checkRemoteTag(onResult) {
  fetchFEBuildTag()
    .then((remoteTag) => {
      onResult(remoteTag === env.getRepositoryTag());
    })
    .catch((error) => {
      log.warning(`Failed to check FE relevance: ${error?.message}`);
    });
}
